import { flatMap, map, some } from 'lodash'

export const hasAdminRole = user => {
  if (user?.dashboardRole === 'admin') return true
  return some(user?.roles, { type: 'admin' })
}

/** Partner dashboard session (from login password or partner-only roles). */
export const isPartnerDashboardUser = user => {
  if (user?.dashboardRole === 'partner') return true
  if (user?.dashboardRole) return false
  return some(user?.roles, { type: 'partner' }) && !some(user?.roles, { type: 'admin' })
}

export const isCompanyDashboardUser = user => {
  if (user?.dashboardRole === 'company') return true
  if (user?.dashboardRole) return false
  return some(user?.roles, { type: 'company' }) && !some(user?.roles, { type: 'admin' }) && !some(user?.roles, { type: 'partner' })
}

export const getDashboardAccessPaths = user => {
  if (isPartnerDashboardUser(user)) {
    return ['/bookings']
  }

  const roles = user?.roles || []
  const rolesForAccess = isCompanyDashboardUser(user) ? roles.filter(role => role.type === 'company') : roles
  return flatMap(rolesForAccess, item => map(item.access, 'menu.pathname'))
}

export const getPostLoginPath = user => {
  if (isPartnerDashboardUser(user)) return '/bookings'
  if (isCompanyDashboardUser(user)) return '/company-dashboard'
  return '/bookings'
}

export const getRootRedirectPath = user => {
  if (isPartnerDashboardUser(user)) return '/bookings'
  if (isCompanyDashboardUser(user)) return '/company-dashboard'
  return '/dashboard'
}

export const mergeDashboardRole = (user, dashboardRole) => {
  if (!user || !dashboardRole) return user
  return { ...user, dashboardRole }
}

/** Shared card-based dashboard UI for company and partner sessions (not admin). */
export const usesTenantDashboardUi = user => {
  if (!user) return false
  if (user.dashboardRole === 'admin') return false
  if (user.dashboardRole === 'partner' || user.dashboardRole === 'company') return true
  if (user.dashboardRole) return false
  if (some(user?.roles, { type: 'admin' })) return false
  return some(user?.roles, { type: 'company' }) || some(user?.roles, { type: 'partner' })
}
